import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Apply Now', href: '/Prism/apply' },
    { name: 'Contract', href: '/Prism/contract' }
  ];

  const isActive = (href) => {
    return location.pathname === href || location.pathname === href.replace(/\/$/, '');
  };

  return (
    <header className="header-container bg-midnight-ink/95 backdrop-blur-md border-b border-prism-violet/20 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-3 hover-lift">
            <img
              src="https://customer-assets.emergentagent.com/job_multi-brand-portal/artifacts/dkrj21tk_Studio%20Prism%20Entertainment%20Logo.png"
              alt="Studio Prism Entertainment"
              className="h-10 w-auto"
            />
            <div className="hidden sm:block">
              <span className="text-xl font-bold text-white">Studio Prism</span>
              <p className="text-xs text-iridescent-silver">Entertainment</p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`nav-link px-3 py-2 rounded-md text-sm font-medium transition-all duration-300 ${
                  isActive(item.href)
                    ? 'text-prism-violet bg-prism-violet/10'
                    : 'text-iridescent-silver hover:text-white hover:bg-white/5'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <button
            className="md:hidden p-2 rounded-md text-iridescent-silver hover:text-white hover:bg-white/5 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-prism-violet/20">
            <div className="flex flex-col space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`nav-link px-3 py-2 rounded-md text-base font-medium transition-all duration-300 ${
                    isActive(item.href)
                      ? 'text-prism-violet bg-prism-violet/10'
                      : 'text-iridescent-silver hover:text-white hover:bg-white/5'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;